<ng-container [formGroup]="form">
	<div class="input-dropdown-container" [ngClass]="{ 'label-left': labelPosition === LABEL_POSITION.LEFT }">
		<label [ngClass]="{ 'hidden-offscreen': hideLabel }" id="{{ label }}LabelText" for="{{ name }}">
			<ea-ui-required-optional [label]="label" [isRequired]="required"></ea-ui-required-optional>
		</label>
		<div class="input-dropdown">
			<select
				id="{{ name }}"
				class="form-control"
				[ngClass]="{
					'field-error': control.submitted && control.errors?.required
				}"
				[formControlName]="name"
				[attr.aria-required]="required"
				[attr.aria-invalid]="control.invalid"
				[attr.aria-describedby]="name + 'Error'"
				[attr.aria-required]="required"
				(change)="handleChange()">
				@if (hasDefaultSelectOption && addDefaultOption) {
					<option [ngValue]="defaultSelectOption.value" class="aut-default-filter" [disabled]="disableDefaultOption">
						{{ defaultSelectOption.display }}
					</option>
				}
				@for (option of options; track option) {
					<option
						[ngValue]="option.value"
						[disabled]="option.disabled"
						class="{{ option.display }}Filter"
						[attr.title]="showTooltip && option.tooltip ? option.tooltip : null">
						{{ option.display }}
					</option>
				}
			</select>
		</div>
	</div>
</ng-container>
<ea-form-control-error
	[submitted]="control.submitted"
	[controlName]="label"
	[customErrors]="customErrorMessages"
	[errors]="control.errors"
	aria-live="assertive"
	id="{{ name }}Error">
</ea-form-control-error>
